import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import EmptyState from '../components/EmptyState';
import InfiniteScrollWaypoint from '../components/InfiniteScrollWaypoint';
import PostRow from '../post/PostRow';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';

const VIEWED_POSTS_QUERY = gql`
  query viewedPosts($afterCursor: String) {
    session: currentSession {
      user {
        id
        viewedPosts(first: 25, after: $afterCursor) {
          edges {
            node {
              ...PostRow_post
              userViewedAt
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
  ${PostRow.fragments.post}
`;

const useViewedPostsColumn = () => {
  const [activePreviewId, setActivePreviewId] = useState(null);

  const result = useQuery(VIEWED_POSTS_QUERY);

  const fetchMore = ConnectionHelper.generateFetchMore(
    VIEWED_POSTS_QUERY,
    result,
    'session.user.viewedPosts',
  );
  const { data } = result;
  const posts = data?.session.user.viewedPosts.edges.map(({ node }) => node);

  return {
    seamless: true,
    title: 'Viewed',
    children:
      posts &&
      (posts.length === 0 ? (
        <EmptyState
          imageName="posts"
          title="Haven't read anything yet."
          message="Browse around. There's something interesting in here somewhere."
        />
      ) : (
        <>
          {posts.map((post, index) => (
            <PostRow
              key={post.id}
              post={post}
              inList={index > 0}
              activePreviewId={activePreviewId}
              onActivePreviewIdChange={setActivePreviewId}
            />
          ))}
          <InfiniteScrollWaypoint fetchMore={fetchMore} />
        </>
      )),
  };
};

export default useViewedPostsColumn;
